import { render } from "./ForcedPasswordResetView.vue?vue&type=template&id=32e7e89e&scoped=true"
import script from "./ForcedPasswordResetView.vue?vue&type=script&lang=js"
export * from "./ForcedPasswordResetView.vue?vue&type=script&lang=js"

import "./ForcedPasswordResetView.vue?vue&type=style&index=0&id=32e7e89e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e7e89e"]])

export default __exports__